export interface SlotType {
    name: string;
    printName: string;
  }
  
  export function createSlotType(name: string, printName: string): SlotType {
    return { name: name, printName: printName };
  }